export const addSourceToURL = (URL, SOURCE) => `${URL}?source=${SOURCE}`;
